import $ from 'jquery';

export class Script {
  public static frontend(el: HTMLElement, opt: any) {
    return new Script(el);
  }
  constructor(el: HTMLElement) {
    const script = el.getElementsByTagName('script').item(0);
    try {
      const jQuery = $();
      // tslint:disable-next-line:no-eval
      eval(script.innerHTML);
    } catch (e) {
      console.error('Error running custom script block');
      console.error(e);
    }
  }
}
